// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-11 — "Pedidos de este plano" dentro de la previsualización.
   Acotado a .analysis-orders: el CSS de CRA es global. */
.analysis-orders {
  /* Franja propia bajo la cabecera: dentro de .preview-title-section el
     desplegable pisaba los botones y recortaba los nombres de cliente. */
  padding: 10px 40px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  /* El botón de presupuestar y el desplegable van en la misma línea; la lista, debajo */
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
}
.analysis-orders .analysis-orders-list { flex-basis: 100%; }

@media (max-width: 760px) {
  .analysis-orders { padding: 10px 16px; }
}

.analysis-orders .analysis-orders-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: transparent;
  color: #6b6b6b;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.15s ease;
}

.analysis-orders .analysis-orders-toggle:hover {
  color: var(--button-color);
  text-decoration: underline;
}

.analysis-orders-hours { color: #999; }

.analysis-orders-caret {
  display: inline-block;
  font-size: 15px;
  line-height: 1;
  transition: transform 0.15s ease;
}

.analysis-orders-caret.open { transform: rotate(90deg); }

.analysis-orders-list {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  border: 1px solid #ececec;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  max-width: 620px;
}

.analysis-orders-list li + li { border-top: 1px solid #f2f2f2; }

.analysis-orders .analysis-orders-item {
  display: grid;
  grid-template-columns: 1fr auto auto auto;
  gap: 12px;
  align-items: center;
  width: 100%;
  padding: 9px 12px;
  border: none;
  background: transparent;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}

.analysis-orders .analysis-orders-item:hover { background: #fafafa; }

.ao-client { font-weight: 500; color: #222; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ao-ref { color: #666; white-space: nowrap; }
.ao-date { color: #888; white-space: nowrap; }
.ao-hours { color: #222; white-space: nowrap; }

@media (max-width: 620px) {
  .analysis-orders .analysis-orders-item { grid-template-columns: 1fr auto; row-gap: 4px; }
}

/* LAKPED-5: el ciclo empieza aquí, presupuestando el plano que se está mirando */
.analysis-orders-quote {
  border: 1px solid #b9d4ef; background: #fff; color: #24527a;
  border-radius: 8px; padding: 6px 12px; font-size: 12.5px; cursor: pointer; white-space: nowrap;
}
.analysis-orders-quote:hover { border-color: #7fb0dd; background: #f3f9ff; }
`, "",{"version":3,"sources":["webpack://./src/components/History/AnalysisOrders.css"],"names":[],"mappings":"AAAA;yDACyD;AACzD;EACE;yEACuE;EACvE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,sFAAsF;EACtF,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;AACA,yCAAyC,gBAAgB,EAAE;;AAE3D;EACE,mBAAmB,kBAAkB,EAAE;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,yBAAyB,WAAW,EAAE;;AAEtC;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA,8BAA8B,wBAAwB,EAAE;;AAExD;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gCAAgC,6BAA6B,EAAE;;AAE/D;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+CAA+C,mBAAmB,EAAE;;AAEpE,aAAa,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5G,UAAU,WAAW,EAAE,mBAAmB,EAAE;AAC5C,WAAW,WAAW,EAAE,mBAAmB,EAAE;AAC7C,YAAY,WAAW,EAAE,mBAAmB,EAAE;;AAE9C;EACE,yCAAyC,+BAA+B,EAAE,YAAY,EAAE;AAC1F;;AAEA,iFAAiF;AACjF;EACE,yBAAyB,EAAE,gBAAgB,EAAE,cAAc;EAC3D,kBAAkB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,eAAe,EAAE,mBAAmB;AAChG;AACA,+BAA+B,qBAAqB,EAAE,mBAAmB,EAAE","sourcesContent":["/* LAKPED-11 — \"Pedidos de este plano\" dentro de la previsualización.\n   Acotado a .analysis-orders: el CSS de CRA es global. */\n.analysis-orders {\n  /* Franja propia bajo la cabecera: dentro de .preview-title-section el\n     desplegable pisaba los botones y recortaba los nombres de cliente. */\n  padding: 10px 40px;\n  background: #fff;\n  border-bottom: 1px solid #e0e0e0;\n  /* El botón de presupuestar y el desplegable van en la misma línea; la lista, debajo */\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px;\n}\n.analysis-orders .analysis-orders-list { flex-basis: 100%; }\n\n@media (max-width: 760px) {\n  .analysis-orders { padding: 10px 16px; }\n}\n\n.analysis-orders .analysis-orders-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #6b6b6b;\n  font-size: 12px;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.analysis-orders .analysis-orders-toggle:hover {\n  color: var(--button-color);\n  text-decoration: underline;\n}\n\n.analysis-orders-hours { color: #999; }\n\n.analysis-orders-caret {\n  display: inline-block;\n  font-size: 15px;\n  line-height: 1;\n  transition: transform 0.15s ease;\n}\n\n.analysis-orders-caret.open { transform: rotate(90deg); }\n\n.analysis-orders-list {\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 0;\n  border: 1px solid #ececec;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n  max-width: 620px;\n}\n\n.analysis-orders-list li + li { border-top: 1px solid #f2f2f2; }\n\n.analysis-orders .analysis-orders-item {\n  display: grid;\n  grid-template-columns: 1fr auto auto auto;\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n  padding: 9px 12px;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.analysis-orders .analysis-orders-item:hover { background: #fafafa; }\n\n.ao-client { font-weight: 500; color: #222; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ao-ref { color: #666; white-space: nowrap; }\n.ao-date { color: #888; white-space: nowrap; }\n.ao-hours { color: #222; white-space: nowrap; }\n\n@media (max-width: 620px) {\n  .analysis-orders .analysis-orders-item { grid-template-columns: 1fr auto; row-gap: 4px; }\n}\n\n/* LAKPED-5: el ciclo empieza aquí, presupuestando el plano que se está mirando */\n.analysis-orders-quote {\n  border: 1px solid #b9d4ef; background: #fff; color: #24527a;\n  border-radius: 8px; padding: 6px 12px; font-size: 12.5px; cursor: pointer; white-space: nowrap;\n}\n.analysis-orders-quote:hover { border-color: #7fb0dd; background: #f3f9ff; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
